<template>
  <div class="from_box flex">
    <div class="item">
      <span class="txt">物料编号：</span>
      <el-input v-model="saleBatchHeader.materialCode" placeholder="暂无物料编号" :disabled="true"></el-input>
    </div>
    <div class="item">
      <span class="txt">物料描述：</span>
      <el-input v-model="saleBatchHeader.materialDesc" placeholder="暂无物料描述" :disabled="true"></el-input>
	    <span style="width:40px;margin-left:10px"></span>
    </div>
    <div class="item" >
       <span class="txt">公司：</span>
       <el-select v-model="saleBatchHeader.companyId"  @change="onChangeCompany"  placeholder="请选择公司">
            <el-option v-for="item in companyDataSet" :label="item.value"
                   :key="item.companyId" :value="item.companyId">
            </el-option>
       </el-select>
    </div>
    <div class="item">
      <span class="txt">采购价：</span>
      <el-input v-model="saleBatchHeader.purchaseCostPrice" :placeholder="$store.state.remark.remark"></el-input>
      <span style="width:40px;margin-left:10px"></span>
    </div>
    <div class="item" >
      <span class="txt">体 积(ML)：</span>
      <el-input v-model="saleBatchHeader.purchaseQty" :placeholder="$store.state.remark.remark"></el-input>
    </div>
    
    <!-- <div class="item">
      <span class="txt">公司：</span>
      <el-select v-model="searchCriteria.companyId" @change="changeCompany" placeholder="请选择公司">
        <el-option
          v-for="item in companyList"
          :label="item.value"
          :key="item.companyId"
          :value="item.companyId"
        ></el-option>
      </el-select>
    </div> -->

	<div class="active_rumb"><span class="txt">基准规格</span></div>
    <div class="item">
      <span class="txt">团购规格：</span>
      <el-input v-model="saleBatchHeader.groupBuyingStandard" :placeholder="$store.state.remark.remark"></el-input>
    </div>
    <div class="item" >
      <span class="txt">批发规格：</span>
      <el-input v-model="saleBatchHeader.wholesalesStandard" :placeholder="$store.state.remark.remark"></el-input>
	  <span style="width:40px;margin-left:10px"></span>
    </div>
    <div class="item">
      <span class="txt">零售规格：</span>
      <el-input v-model="saleBatchHeader.retailStandard" :placeholder="$store.state.remark.remark"></el-input>
     </div>

    <div class="active_rumb"><span class="txt">加价倍数</span></div>
      <div class="item">
         <span class="txt">团购加倍：</span>
         <el-input v-model="saleBatchHeader.groupBuyingDouble" :placeholder="$store.state.remark.remark"></el-input>
         <span class="txt">{{groupBuyingPriceDesc}}</span>
         <!-- <el-input v-model="groupBuyingPrice" style="width:100px;" :placeholder="$store.state.remark.remark"></el-input> -->
      </div>
      <div class="item" >
         <span class="txt">批发加倍：</span>
         <el-input v-model="saleBatchHeader.wholesalesDouble" :placeholder="$store.state.remark.remark"></el-input>
         <span class="txt">{{wholesalesPriceDesc}}</span>
         <!-- <el-input v-model="wholesalesPrice" style="width:100px;" :placeholder="$store.state.remark.remark"></el-input> -->
      <span style="width:40px;margin-left:10px"></span>
      </div>
      <div class="item">
         <span class="txt">零售加倍：</span>
         <el-input v-model="saleBatchHeader.retailDouble" :placeholder="$store.state.remark.remark"></el-input>
         <span class="txt">{{retailPriceDesc}}</span>
         <!-- <el-input v-model="retailPrice" style="width:100px;" :placeholder="$store.state.remark.remark"></el-input> -->
      </div>

    <div class="active_rumb"><span class="txt">优惠折扣</span></div>
    <div class="item">
      <span class="txt">折扣率：</span>
      <el-input v-model="saleBatchHeader.doublingCoefficient" :placeholder="$store.state.remark.remark"></el-input>
	  <span style="width:40px;line-height:40px;margin-left:10px;font-size:16px">%</span>
    </div>

  </div>
</template>

<script>
import { company as companyUrl} from "api/system.js";
export default {
    props:{
        formData: Object
    },
    data(){
        return {
            saleBatchHeader:this.formData,
            companyDataSet:[]
        }
    },
    created(){
      //加载公司信息
      this.loadCompanyDataset();
      this.companyDataSet=this.$store.state.cache.companyList;
    },
    computed:{
        groupBuyingPriceDesc:function(){  
          let  purchaseCostPrice, purchaseQty,groupBuyingStandard,groupBuyingDouble,groupBuyingPrice;
          purchaseCostPrice=this.saleBatchHeader.purchaseCostPrice||0;
          purchaseQty=this.saleBatchHeader.purchaseQty||0;
          groupBuyingStandard=this.saleBatchHeader.groupBuyingStandard||0;
          groupBuyingDouble=this.saleBatchHeader.groupBuyingDouble||0;          

          groupBuyingPrice=purchaseCostPrice/purchaseQty*groupBuyingStandard*groupBuyingDouble;
          this.saleBatchHeader.groupBuyingPrice=this.toDecimal(groupBuyingPrice);
          if(this.saleBatchHeader.groupBuyingPrice){
            return "团购价"+this.saleBatchHeader.groupBuyingPrice+"元";
          }else{
            return ""
          }
        },
        wholesalesPriceDesc:function(){
          let  purchaseCostPrice, purchaseQty,wholesalesStandard,wholesalesDouble,wholesalesPrice;
          purchaseCostPrice=this.saleBatchHeader.purchaseCostPrice||0;
          purchaseQty=this.saleBatchHeader.purchaseQty||0;
          wholesalesStandard=this.saleBatchHeader.wholesalesStandard||0;
          wholesalesDouble=this.saleBatchHeader.wholesalesDouble||0;          

          wholesalesPrice=purchaseCostPrice/purchaseQty*wholesalesStandard*wholesalesDouble;
          this.saleBatchHeader.wholesalesPrice=this.toDecimal(wholesalesPrice);

          if(this.saleBatchHeader.wholesalesPrice){
            return "批发价"+this.saleBatchHeader.wholesalesPrice+"元";
          }else{
            return ""
          }
        },
        retailPriceDesc:function(){
          let  purchaseCostPrice, purchaseQty,retailStandard,retailDouble,retailPrice;
          purchaseCostPrice=this.saleBatchHeader.purchaseCostPrice||0;
          purchaseQty=this.saleBatchHeader.purchaseQty||0;
          retailStandard=this.saleBatchHeader.retailStandard||0;
          retailDouble=this.saleBatchHeader.retailDouble||0;


          retailPrice=purchaseCostPrice/purchaseQty*retailStandard*retailDouble
          this.saleBatchHeader.retailPrice=this.toDecimal(retailPrice);
          if(this.saleBatchHeader.retailPrice){
            return "零售价"+this.saleBatchHeader.retailPrice+"元";
          }else{
            return ""
          }
        }
    },
    methods:{
      /**
       * 更改公司
       */
      onChangeCompany(){        
        let companyRec = this.companyDataSet.find(item=>item.companyId==this.saleBatchHeader.companyId);
        if(companyRec){
          this.saleBatchHeader.companyCode = companyRec.companyCode;
          this.saleBatchHeader.companyDesc= companyRec.companyName;
        }else{
          this.saleBatchHeader.companyId="";
          this.saleBatchHeader.companyCode ="";
          this.saleBatchHeader.companyDesc="";
        }
      },
      async loadCompanyDataset(){  
        debugger;      
        if (!this.$store.state.cache.companyList) {
          let companyList = await this.$post(companyUrl.list,this.$store.state.getAllPage);          
          if (companyList.status) {
              //补充value值
              companyList.data.list.forEach(item => {
                  item.value = item.companyCode + "-" + item.companyName;
              });
              this.$store.state.cache.companyList = companyList.data.list;           
          } else {
              this.$store.state.cache.companyList = null;
          }
        }
      },
      toDecimal(decimal) {   
        var decimal= parseFloat(decimal);
        if (isNaN(decimal)) {   
          return;    
        } 
        return Math.round(decimal);                 
        //return Math.round(decimal*100)/100               
      }
    }
}
</script>